import { defineCustomElement } from 'vue'
import Main from './main'
import store from './store'
import { addFonts, mergeConfigInState } from './utils/index'
const defaultFonts = require('../src/styles/3-Elements/_elements.fonts.scss')
    .default[0][1]

/**
 * Creates a new instance
 * @param {Element} parentElement The parent element to mount on
 * @param {boolean} previewMode Preview mode doesn't use cache and mounts on different element
 */
export const createNewInstance = async (wcfcId, isPreviewMode) => {
    try {
        const { actions, state } = store
        const customElementName = `wcfc-${wcfcId}`
        const config = await actions.getConfig(wcfcId, isPreviewMode)
        let FaqModule = customElements.get(customElementName)

        const parentElement = getParentElement({
            wcfcId,
            configParentSelector: config.parentSelector,
            isPreviewMode
        })

        mergeConfigInState(state, config)

        // Only define custom element if the Faq Module is not in the CustomElementRegistry
        if (!FaqModule) {
            FaqModule = defineCustomElement(Main)
            customElements.define(customElementName, FaqModule, {})
        }

        const app = new FaqModule({})

        // Don't mount if the application is already mounted in the DOM
        if (parentElement.querySelector(app.localName)) {
            return
        }

        parentElement.setAttribute('data-wcfc-id', wcfcId)
        addFonts(parentElement, defaultFonts)

        parentElement.appendChild(app)
    } catch (error) {
        console.error(error)
    }
}

/**
 * Gets Parent Element where the widget will attach to, or creates a new root
 * @param {String} wcfcId The config id
 * @param {Object} config The core config
 * @returns {HTMLElement|null} HTMLElement or null
 */
export const getParentElement = ({ wcfcId, configParentSelector, isPreviewMode }) => {
    const existingInstance = document.querySelector(`[data-wcfc-id="${wcfcId}"]`)

    if (existingInstance) {
        return existingInstance
    }

    if (isPreviewMode) {
        const previewModeElement = document.querySelector('[data-web-conversations-preview]')

        if (previewModeElement) {
            return previewModeElement
        }
    }

    if (configParentSelector) {
        const configParentElement = document.querySelector(configParentSelector)

        if (configParentElement) {
            return configParentElement
        }
    }

    throw new Error('Could not mount FAQ application on provided parent selector', configParentSelector)
}

createNewInstance(window.wcfc_id, window.wcfc_preview_mode)
